'use client';

import CarouselWrapper from '@/components/common/CarouselWrapper';
import { Reference } from '@/actions/directus';
import React from 'react';
import TestimonialBlockElement from './TestimonialBlockElement';

interface TestimonialBlockProps {
  references: Reference[];
}

const TestimonialBlock: React.FC<TestimonialBlockProps> = ({ references }) => {
  return (
    <CarouselWrapper
      items={references}
      renderCard={(reference: Reference, index: number) => (
        <TestimonialBlockElement reference={reference} key={index} />
      )}
    />
  );
};

export default TestimonialBlock;
